import * as axios from 'axios';
import * as utils from '../shared/service-utils';

import { API } from '../shared/config';

export default {
  methods: {
    async getPaidPreparerDetails(userId) {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.get(`${API}/customer/${userId}`, { headers: hdr });
        const data = this.parseSingletonResult(response);
        // console.log('getPaidPreparerDetails:', JSON.stringify(data));
        return data;
      } catch (error) {
        console.error(error);
        return {};
      }
    },
    async getPaidPreparersList() {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.get(`${API}/customers`, { headers: hdr });
        const data = this.parseList(response);
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    async getBillingDocInfoForSingleCustomer(userId) {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.get(`${API}/customer/billing-docs/${userId}`, { headers: hdr });
        const data = this.parseSingletonResult(response);
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    async getNotesForSingleCustomer(userId) {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.get(`${API}/customers/${userId}/notes`, { headers: hdr });
        const data = this.parseSingletonResult(response);
        return data;
      } catch (error) {
        console.error(error);
        return [];
      }
    },
    async addNote(userId, payload) {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.post(`${API}/customer/${userId}/note`, payload, { headers: hdr });
        const data = this.parseResult(response);
        return data;
      } catch (error) {
        console.error(error);
        return {};
      }
    },
    async updateActiveStatusForPP(userId, payload) {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.post(`${API}/customer/update-status/${userId}`, payload, { headers: hdr });
        const data = this.parseResult(response);
        return data;
      } catch (error) {
        console.error(error);
        return {};
      }
    },
    async updateUnitCostForPP(userId, payload) {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.post(`${API}/customer/update-cost/${userId}`, payload, { headers: hdr });
        const data = this.parseSingletonResult(response);
        return data;
      } catch (error) {
        console.error(error);
        return {};
      }
    },
    async updateAdjustmentForPP(userId, payload) {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.post(`${API}/customer/update-adjustment/${userId}`, payload, { headers: hdr });
        const data = this.parseSingletonResult(response);
        return data;
      } catch (error) {
        console.error(error);
        return {};
      }
    },
    async updateBillStatusForPP(userId, payload) {
      try {
        const hdr = await utils.getAuthHeader();
        const response = await axios.post(`${API}/customer/update-bill-status/${userId}`, payload, { headers: hdr });
        const data = this.parseSingletonResult(response);
        return data;
      } catch (error) {
        console.error(error);
        return {};
      }
    },
    parseList(response) {
      if (response.status !== 200) throw Error(response.message);
      if (!response.data) return [];
      const list = response.data;
      return list;
    },

    parseResult(response) {
      if (response.status !== 200) throw Error(response.message);
      if (!response.data || response.data.length !== 1) return {};
      const resp = response.data[0];
      return resp;
    },
    parseSingletonResult(response) {
      if (response.status !== 200) throw Error(response.message);
      if (!response.data) return {};
      const rawData = response.data;
      return rawData;
    },
  },
};
